import { createContext, useContext } from 'react';

// True when a component is rendered inside AppShell.
// AppHeader reads this to avoid rendering a duplicate header.
export const ShellContext = createContext(false);
export const useIsInsideShell = () => useContext(ShellContext);